var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "c-buffer-box c-buffer-box--vertical c-buffer-box--super-tight-top-ends t-border-green"
    },
    [
      _c(
        "form",
        {
          staticClass: "c-form c-competence-card-competence__form",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.handleSubmit($event)
            }
          }
        },
        [
          _c("fieldset", [
            _c("div", { staticClass: "o-grid o-grid--align-center" }, [
              _c(
                "div",
                {
                  staticClass: "o-grid__column",
                  attrs: { "data-size": "sm:12 md:8 lg:8" }
                },
                [
                  _vm.mode === "create"
                    ? _c("dropdown-variations", {
                        ref: "competence",
                        attrs: {
                          "item-groups": _vm.competenceOptions,
                          label: "Välj kompetensområde",
                          value: { id: _vm.id, name: _vm.name },
                          "allow-custom-value": true,
                          filterable: true
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mode === "edit"
                    ? _c(
                        "div",
                        { staticClass: "c-form__item" },
                        [
                          _c("vue-input", {
                            attrs: {
                              label: "Kompetens",
                              value: _vm.category + ": " + _vm.name,
                              disabled: "disabled"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "o-grid__column",
                  attrs: { "data-size": "sm:11 md:3 lg:3" }
                },
                [
                  _c("dropdown-variations", {
                    ref: "level",
                    attrs: {
                      "item-groups": _vm.competenceLevelOptions,
                      label: "Välj kompetensnivå",
                      value: { id: _vm.level, name: _vm.level }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "o-grid__column",
                  attrs: { "data-size": "sm:1 md:1 lg:1" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "c-competence-card-competence__levels c-form__item",
                      attrs: { href: "#" },
                      on: { click: _vm.toggleLevelsModal }
                    },
                    [_c("vue-icon", { attrs: { name: "info" } })],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "o-grid__column",
                  attrs: { "data-size": "sm:11 md:11 lg:11" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "c-form__item" },
                    [
                      _c("vue-input", {
                        ref: "note",
                        attrs: {
                          label: "Notering",
                          "input-id": "note-" + _vm.id,
                          value: _vm.note,
                          required: false
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "o-grid__column",
                  attrs: { "data-size": "sm:11 md:11 lg:11" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "c-form__item" },
                    [
                      _c("vue-input", {
                        ref: "printOption",
                        attrs: {
                          type: "checkbox",
                          label: "Visa på kompetenskort",
                          inputId: "" + ("printOption-" + _vm.id),
                          checked:
                            _vm.mode === "create" ||
                            _vm.printOption === "Display"
                              ? "checked"
                              : null
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "o-grid o-grid--align-center  t-margin-bottom-xs t-margin-top-s"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "o-grid__column",
                    attrs: { "data-size": "sm:12 md:6 lg:6" }
                  },
                  [
                    _c("div", { staticClass: "t-text-align-left" }, [
                      _vm.mode === "edit"
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "c-button c-button--linkstyle c-button--linkstyle__secondary c-button--reset",
                              attrs: { type: "submit" },
                              on: { click: _vm.toggleDeleteModal }
                            },
                            [_vm._v("Ta bort kompetens")]
                          )
                        : _vm._e()
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "o-grid__column",
                    attrs: { "data-size": "sm:12 md:5 lg:5" }
                  },
                  [
                    _c("div", { staticClass: "t-text-align-right" }, [
                      _vm.mode === "create"
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "c-button c-button--linkstyle c-button--reset",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.cancelCreateCompetence($event)
                                }
                              }
                            },
                            [_vm._v("Avbryt")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mode === "create"
                        ? _c(
                            "button",
                            {
                              staticClass: "c-button c-button--primary",
                              attrs: { type: "submit" },
                              on: {
                                click: function($event) {
                                  return _vm.setSubmitType("create")
                                }
                              }
                            },
                            [_vm._v("Spara")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mode === "edit"
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "c-button c-button--linkstyle c-button--reset",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.cancelEditCompetence($event)
                                }
                              }
                            },
                            [_vm._v("Avbryt")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mode === "edit"
                        ? _c(
                            "button",
                            {
                              staticClass: "c-button c-button--primary",
                              attrs: { type: "submit" },
                              on: {
                                click: function($event) {
                                  return _vm.setSubmitType("edit")
                                }
                              }
                            },
                            [_vm._v("Spara")]
                          )
                        : _vm._e()
                    ])
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: { show: _vm.showLevelsModal },
              on: { closeModal: _vm.toggleLevelsModal }
            },
            [
              _c(
                "div",
                { staticClass: "c-modal__content t-background-white s-text" },
                [
                  _c("h1", [_vm._v("Information om nivåer")]),
                  _vm._v(" "),
                  _c("table", [
                    _c("tr", [
                      _c("td", [_c("b", [_vm._v("Bas")])]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "Är inte mångsidig, löser sällan problem själv. Liten erfarenhet av arbetsuppgifterna, arbetar inte ensam."
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_c("b", [_vm._v("God")])]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "Är inte så mångsidig, löser dock oftast problemen själv. Har erfarenhet av arbetsuppgifterna. Kan arbeta självständigt men utmärker sig inte."
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_c("b", [_vm._v("Hög")])]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "Är mångsidig, löser problem själv utöver det normala. Har stor erfarenhet av arbetsuppgifterna."
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_c("b", [_vm._v("Spets")])]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "Är mycket mångsidig, löser problem åt kunden som bidrar väsentligt till företagets utveckling och resultat i positiv riktning. Är en nyckelperson i företaget med sin erfarenhet."
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "t-text-align-center" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "c-button c-button--linkstyle c-button--reset t-margin-top-s",
                        attrs: { type: "button" },
                        on: { click: _vm.toggleLevelsModal }
                      },
                      [_vm._v("Stäng")]
                    )
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: { show: _vm.showDeleteModal },
              on: { closeModal: _vm.toggleDeleteModal }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "c-modal__content t-background-white t-text-align-center"
                },
                [
                  _c(
                    "h1",
                    { staticClass: "t-text-style-alpha t-margin-bottom-s" },
                    [
                      _vm._v("Du tar nu bort kompetensen "),
                      _vm.competence
                        ? _c("span", [
                            _vm._v('"' + _vm._s(_vm.competence.name) + '"')
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "c-form",
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.handleSubmit($event)
                        }
                      }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "c-button c-button--linkstyle c-button--reset t-margin-top-m",
                          on: { click: _vm.toggleDeleteModal }
                        },
                        [_vm._v("Avbryt")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "c-button c-button--primary t-margin-top-m",
                          attrs: { type: "submit" },
                          on: {
                            click: function($event) {
                              return _vm.setSubmitType("delete")
                            }
                          }
                        },
                        [_vm._v("Ta bort")]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }